import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Interweave } from "interweave";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import
{
  BASE_URL,
  GET_CONTENTS_BY_MENU_ID,
  GET_IMAGE_BY_MENU_ID,
  GET_MENU_ITEM_BY_ID
} from "../../constant/constants";

function items ( obj )
{
  let content = [];

  // eslint-disable-next-line no-unused-vars
  for ( let key in obj )
  {
    let contentItem = {};
    let objs = obj;

    contentItem[ `${ key }` ] = objs[ key ];
    content.push( contentItem );
  }
  return content;
}

const EventsDatils = ( props ) =>
{
  const { id, eventName } = useParams();
  const { fdkfcjxzkcjx } = useParams();

  console.log( 'eventName', fdkfcjxzkcjx )
  const [ menuContent, setMenuContent ] = useState( {} );
  const [ contents, setContents ] = useState( [] );
  const [ contentsImage, setContentsImage ] = useState( "" );
  const [ blogData, setBlogData ] = useState( {
    content: "",
    image: "",
  } );




  useEffect( () =>
  {
    if ( !blogData?.content )
    {
      fetch( `${ GET_CONTENTS_BY_MENU_ID }/${ id }` )
        .then( ( response ) => response.json() )
        .then( ( data ) =>
        {
          if ( data )
          {
            console.log( "data12212121", data?.menu_contents );
            setContents( data.menu_contents );
            setBlogData( {
              ...blogData,
              content: data?.menu_contents.find( content => content.name === eventName )?.value,
            } );
          }
        } )
        .catch( () => { } );
    }

    // Get Content Image
    if ( !blogData?.image )
    {
      fetch( `${ GET_IMAGE_BY_MENU_ID }/${ id }` )
        .then( ( response ) => response.json() )
        .then( ( data ) =>
        {
          if ( data )
          {
            setContentsImage( data.content_images );
            setBlogData( {
              ...blogData,
              image: data?.content_images[ eventName ],
            } );
          }
        } )
        .catch( () => { } );
    }
  }, [ blogData, eventName, id ] );

  useEffect( () =>
  {
    fetch( `${ GET_MENU_ITEM_BY_ID }/${ id }` )
      .then( ( response ) => response.json() )
      .then( ( data ) =>
      {
        setMenuContent( data );

        console.log( "allmenucontent", data );
      } )
      .catch( () => { } );
  }, [ id ] );


  return (
    <Fragment>
      <section className="wpo-project-single-section section-padding">
        <div className="container" style={ { padding: '0', width: '100%', margin: '0 auto' } }>
          <div className="row" style={ { margin: '0', width: '100%' } }>
            <div className="col-lg-10 offset-lg-1" style={ { padding: '0' } }>
              <div style={ { width: '100%', margin: '0 auto' } }>
                <div style={ { width: '100%', maxWidth: '100%', margin: '0', padding: '0' } }>
                  <div style={ { width: '100%', margin: '0', padding: '0' } }>
                    <div className="row" style={ { margin: '0' } }>
                      <div className="col-lg-12" style={ { padding: '0' } }>
                        <div style={ {
                          width: '100%',
                          margin: '0',
                          padding: '0',
                          overflow: 'hidden'
                        } }>
                          <img
                            src={ `${ BASE_URL }/media/${ blogData?.image }` }
                            alt=""
                            style={ {
                              width: '100%',
                              height: 'auto',
                              display: 'block',
                              margin: '0 auto',
                              maxWidth: '100%',
                              objectFit: 'cover'
                            } }
                          />
                        </div>
                        <div style={ { marginTop: '20px', width: '100%' } }>
                          <Interweave
                            allowAttributes
                            allowElements
                            disableLineBreaks={ true }
                            content={ blogData?.content }
                            style={ { width: '100%' } }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default EventsDatils;
